import React from "react";

const VisionMision = () => {
  return (
    <div>
      <div className="section-head col-sm-12">
        <h4>
          <span>Mission, Vision & </span> Philosophy
        </h4>
      </div>
      <div className="container">
          <div className="row">
          <div class="col-lg-4 col-sm-6">
            <div class="item">
              <span class="icon feature_box_col_one">
                <i class="fa fa-globe"></i>
              </span>
              <h6>Our Mission</h6>
              <p>
              We are poised to make a most resounding impact on quality education by ensuring that solid foundation of the highest standard is entrenched at the pre-tertiary levels, through the administration of our expert examination and allied services.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="item">
              <span class="icon feature_box_col_two">
                <i class="fa fa-anchor"></i>
              </span>
              <h6>Our Vision</h6>
              <p>
              Best Brain Examinations Konsortium brews a robust vision to become a premier edupreneurship entity in the West African sub-region, analogous to the West African Examinations Council.
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-sm-6">
            <div class="item">
              <span class="icon feature_box_col_three">
                <i class="fa fa-hourglass-half"></i>
              </span>
              <h6>Our Philosophy</h6>
              <p>
              Our vision, mission and operational strategy is anchored on the principle that the resourcefulness of the child
               as an asset for national development hinges on our ability to tap the inherent potentials through tested paradigm.
              </p>
            </div>
          </div>
          </div>
      </div>
    </div>
  );
};

export default VisionMision;
